import { Stack } from "@mui/material";
import React from "react";

import Card8 from "./Card8";
import Card7 from "./Card7";

const BottomSection = () => {
  return (
    <Stack
      sx={{
        // width: { xl: "72%", lg: "86%", md: "86%", sm: "70%" },
        // display: "flex",
        display: {
          xl: "flex",
          lg: "flex",
          md: "flex",
          sm: "flex",
          xs: "none",
        },
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        // border: "2px solid green",
      }}
    >
      <Stack
        sx={{
          // border: "1px solid red",
          display: "flex",
          flexDirection: " row",
          justifyContent: "center",
          alignItems: "center",
          marginRight: { xl: "4px" },
          marginBottom: "80px",
          paddingLeft: {
            xl: "0px",
            lg: "0px",
            md: "0px",
            sm: "0px",
            xs: "12px",
          },
          paddingRight: {
            xl: "0px",
            lg: "0px",
            md: "0px",
            sm: "0px",
            xs: "12px",
          },
          width: { xl: "100%", lg: "100%", md: "93%", sm: "70%" },
          marginTop: { xl: "0px", lg: "0px", md: "16px", sm: "0px" },
        }}
      >
        <Stack
          sx={{
            width: { xl: "72%", lg: "85%", md: "99%", xs: "100%" },
            // border: "1px solid blue",
            display: "flex",
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "row",
              xs: "column",
            },
            justifyContent: "space-between",
            gap: 2,
            paddingLeft: {
              xl: "0px",
              lg: "0px",
              md: "24px",
              sm: "16px",
              xs: "0px",
            },
            paddingRight: {
              xl: "0px",
              lg: "0px",
              md: "24px",
              sm: "16px",
              xs: "0px",
            },
          }}
        >
          <Stack
            sx={{
              width: { xl: "50%", xs: "100%" },
            }}
          >
            <Card7 />
          </Stack>
          <Stack
            sx={{
              width: { xl: "50%", xs: "100%" },
            }}
          >
            <Card8 />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default BottomSection;
